import { GeneratedReport, GeneratedReportStatus } from '@interfaces/report-templates.interface';
import { CommonDataset } from '@pages-clean/shared/types';
import { AuditServiceType } from 'types/graphql-global-types';
import { auditRecordIdPrefixes } from '@queries/generated/audit.generated';

export const getGeneratedReportsGridData = (
    reports: GeneratedReport[] | undefined,
    datasets: CommonDataset[],
    prefixes?: auditRecordIdPrefixes['auditRecordIdPrefixes'],
): GeneratedReport[] => {
    if (!reports) return [];

    const prefix = prefixes?.find((p) => p?.service === AuditServiceType.REPORTING)?.prefix;

    return reports.map<GeneratedReport>((report) => {
        const datasetValue = datasets.find((dataset) => dataset?.id === report.datasetId);
        const comparisonDatasetValue = datasets?.find((dataset) => dataset?.id === report.comparisonDatasetId);

        const dataCutDate = datasetValue?.dataCutDate;
        const comparisonDataCuteDate = comparisonDatasetValue?.dataCutDate;

        return {
            ...report,
            fullName: report.includeInternalRisks ? `INTERNAL ${report.reportName}` : report.reportName,
            dataset: dataCutDate,
            comparisonDataset: comparisonDataCuteDate,
            _status: GeneratedReportStatus[report.status!], // Status column. Might not need once cell is worked out
            _itemId: `${prefix}${report.recordId}`, // Record ID col in grid
        };
    });
};
